module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch10"
    }
  }, [_c('b', [_vm._v("Everyday Inventions")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Who invented the coat hanger? Historians say Thomas Jefferson.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Hungarian László Bíró, who patented the ballpoint pen, was also a sculptor and hypnotist.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Pizza was invented in 1889 by Raffaele Esposito in Naples, Italy.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The Countess du Barry, mistress of France’s King Louis XV, invented the fishbowl.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Bette Nesmith Graham, mother of Monkee Mike Nesmith, invented Liquid Paper in the 1950s.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Jack Johnson, the first African American world heavyweight boxing champion, invented the common household wrench.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Band-Aid is the trademarked name for the 1921 invention of Earle Dickson.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("William Blackstone of Indiana invented the washing machine in 1874 as a birthday gift for his wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Marion Donovan made the first diaper cover out of a shower curtain.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Coca-Cola, invented by Dr. John S. Pemberton in 1885, was originally sold as a “brain tonic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first pencil with an attached eraser was invented in 1858 by Hymen L. Lipman of Philadelphia.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("A cigar-smoking lawyer from Lima, Pennsylvania, named Joshua Pusey invented book matches in 1889.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The pop-top can was invented by Ermal Fraze of Kettering, Ohio, in 1959.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Thor Bjørklund, a Norwegian, came up with the first cheese slicer in 1925.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7819eb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter10.vue
// module id = 102
// module chunks = 0